import { Card, CardGrid, Loader, ModalRoute, Pagination } from 'components';
import { getUserName } from 'model/User';
import React, { FC, useEffect } from 'react';
import { getPageFromQuery } from 'utils/getPageFromQuery';
import { getUserType } from 'utils/getUserType';
import { Loading } from '../../styles';
import { useConnect } from './connect';
import Preview from './Preview';
import { Container, Link, SearchOptionsExercises } from './styles';
import { Props } from './types';

const Exercises: FC<Props> = ({ contentRef, user }) => {
  const {
    getUserExerciseResponses,
    items,
    loading,
    pageCount,
    path,
    search,
    state,
    url,
  } = useConnect({ user });
  const page = getPageFromQuery(search);

  const userSlug = user.slug;

  useEffect(() => {
    getUserExerciseResponses({ search, page, slug: userSlug });
  }, [getUserExerciseResponses, search, page, userSlug]);

  if (loading && !items.length) {
    return (
      <Loading>
        <Loader />
      </Loading>
    );
  }

  return (
    <Container>
      <SearchOptionsExercises
        contentType="exercise"
        searchPlaceholder="Search..."
      />
      <CardGrid>
        {items.map(
          ({
            commentsCount,
            hits,
            id,
            mediaList,
            lastComment,
            tags,
            title,
            user,
            votesCount,
            exerciseSlug,
            slug,
          }) => (
            <Link
              key={id}
              to={{
                pathname: `${url}/${exerciseSlug}/${slug}`,
                state: {
                  scrollToTop: false,
                },
              }}
            >
              <Card
                authorAvatar={user.avatar}
                authorName={getUserName(user)}
                authorType={getUserType(user)}
                comments={commentsCount}
                datapoints={votesCount}
                lastCommentDate={lastComment ? lastComment : undefined}
                statuses={[]}
                tags={tags}
                thumbnail={mediaList?.mainMedia}
                title={title}
                views={hits}
              />
            </Link>
          ),
        )}
      </CardGrid>
      <Pagination
        contentRef={contentRef}
        current={Math.min(page, pageCount)}
        state={state}
        total={pageCount}
        url={url}
      />
      <ModalRoute
        component={Preview}
        path={`${path}/:exerciseSlug/:submissionSlug`}
      />
    </Container>
  );
};

export default Exercises;
